var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.LayoutType} ${_vm.Theme}`},[(!_vm.setHorizontalLayout)?_c('VerticalSidebar'):_vm._e(),_c('aside',{class:_vm.setHorizontalLayout == true
                ? 'horizontal-page-wrapper'
                : 'page-wrapper'},[(!_vm.setHorizontalLayout)?_c('VerticalHeader'):_vm._e(),(_vm.setHorizontalLayout)?_c('HorizontalHeader'):_vm._e(),(_vm.setHorizontalLayout)?_c('HorizontalSidebar'):_vm._e(),_c('div',{staticClass:"min-height",class:_vm.setHorizontalLayout == true
                    ? 'container-fluid p-4'
                    : 'container-fluid p-4'},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }